import useUniqueId from "../../hooks/useUniqueId";
import { isSpecialKey } from "../../utils/EventHelpers";
const prefixId = "nx-button-";
const useButtonProps = ({ id: defaultId, type = "button", disabled = false, onClick, as, tabIndex, }) => {
    const id = useUniqueId(prefixId, defaultId);
    const baseProps = {
        id,
        type,
        disabled,
        "aria-disabled": disabled || undefined,
        // we allow tabIndex to be overridden
        tabIndex: disabled ? -1 : tabIndex,
    };
    if (disabled || !onClick) {
        return baseProps;
    }
    const clickHandler = (e) => {
        const { nativeEvent: { isTrusted, detail = 1 }, } = e;
        e.stopPropagation();
        // normal button prevents default
        if (!as) {
            e.preventDefault();
        }
        // isTrusted = false on jest; actual clicks have detail > 1, otherwise it's a Enter or Space event
        if (isTrusted && detail === 0) {
            return;
        }
        !isSpecialKey(e) && onClick(e);
    };
    const keyDownHandler = (e) => {
        if (e.key !== "Enter" && (e.key !== " " || as)) {
            return;
        }
        e.stopPropagation();
        // normal button prevents default
        if (!as) {
            e.preventDefault();
        }
        !isSpecialKey(e) && onClick(e);
    };
    return Object.assign(Object.assign({}, baseProps), { onClick: clickHandler, onKeyDown: keyDownHandler });
};
export default useButtonProps;
//# sourceMappingURL=useButtonProps.js.map